export const NeonHexagonLoader = ({
  size = 60,
  primaryColor = "#00ffff",
  secondaryColor = "#ff00ff",
}) => {
  const neonHexagonStyles = `
    .neon-hexagon {
      width: ${size}px;
      height: ${size}px;
      position: relative;
      animation: neonSpin 2s linear infinite;
    }

    .neon-hexagon::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      border: 3px solid ${primaryColor};
      border-radius: 12px;
      transform: rotate(45deg);
      box-shadow: 0 0 20px ${primaryColor}, inset 0 0 20px ${primaryColor};
      animation: neonGlow 1.5s ease-in-out infinite alternate;
    }

    .neon-hexagon::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 30%;
      height: 30%;
      background: ${primaryColor};
      border-radius: 50%;
      transform: translate(-50%, -50%);
      box-shadow: 0 0 15px ${primaryColor};
      animation: neonPulse 1s ease-in-out infinite;
    }

    @keyframes neonSpin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes neonGlow {
      0% { 
        border-color: ${primaryColor}; 
        box-shadow: 0 0 20px ${primaryColor}, inset 0 0 20px ${primaryColor}; 
      }
      100% { 
        border-color: ${secondaryColor}; 
        box-shadow: 0 0 30px ${secondaryColor}, inset 0 0 30px ${secondaryColor}; 
      }
    }

    @keyframes neonPulse {
      0%, 100% { transform: translate(-50%, -50%) scale(1); }
      50% { transform: translate(-50%, -50%) scale(1.3); }
    }
  `;

  return (
    <>
      <style>{neonHexagonStyles}</style>
      <div className="neon-hexagon"></div>
    </>
  );
};

export const HolographicRingLoader = ({ size = 70 }) => {
  const holographicRingStyles = `
    .holographic-ring {
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      position: relative;
      background: conic-gradient(from 0deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7, #dda0dd, #ff6b6b);
      animation: holoRotate 3s linear infinite;
      padding: 4px;
    }

    .holographic-ring::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      right: 4px;
      bottom: 4px;
      background: #1a1a2e;
      border-radius: 50%;
    }

    .holographic-ring::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: ${size * 0.43}px;
      height: ${size * 0.43}px;
      background: radial-gradient(circle, rgba(255,255,255,0.8), transparent);
      border-radius: 50%;
      transform: translate(-50%, -50%);
      animation: holoInner 2s ease-in-out infinite;
    }

    @keyframes holoRotate {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes holoInner {
      0%, 100% { 
        transform: translate(-50%, -50%) scale(1); 
        opacity: 0.8; 
      }
      50% { 
        transform: translate(-50%, -50%) scale(1.2); 
        opacity: 0.4; 
      }
    }
  `;

  return (
    <>
      <style>{holographicRingStyles}</style>
      <div className="holographic-ring"></div>
    </>
  );
};
